export const getLatestVersionObject = (data) => {
  function compareVersions(version1, version2) {
    if (version1 && version2)
      return version1.localeCompare(version2, 'en', { numeric: true });
    return 0;
  }

  return data.reduce((latest, current) => {
    return compareVersions(current.version, latest.version) > 0 ? current : latest;
  });
};

export const isValidUuid = (str) => {
  const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
  return typeof str === "string" && uuidRegex.test(str);
};
